// src/app/core/chatPage/chatComponents/components/Header.tsx
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface HeaderProps {
  onNavigateBack: () => void;
  activeTab: 'create' | 'chats' | 'models';
  onTabChange: (tab: 'create' | 'chats' | 'models') => void;
  onOpenProSettings?: () => void;
}

export const Header = ({ onNavigateBack, activeTab, onTabChange, onOpenProSettings }: HeaderProps) => {
  const { t } = useTranslation();
  
  const tabs = [
    { key: 'create' as const, label: t('create') },
    { key: 'chats' as const, label: t('chats') },
    { key: 'models' as const, label: t('models') },
  ];

  return (
    <div className="sticky top-0 z-40 px-3 py-2 flex items-center gap-2 bg-transparent">
      {/* Кнопка назад */}
      <button
        onClick={onNavigateBack}
        aria-label={t("back")}
        className="p-1.5 rounded-lg hover:bg-white/10 dark:hover:bg-white/10 transition-colors"
      >
        <ArrowLeft className="h-5 w-5 text-foreground" />
      </button>

      {/* Центрированный переключатель вкладок */}
      <div className="flex-1 flex justify-center">
        <div className="flex items-center bg-white/20 dark:bg-white/10 rounded-full p-0.5 backdrop-blur-md">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={`py-1.5 px-3 text-xs font-medium rounded-full transition-all ${
                activeTab === tab.key
                  ? 'bg-white/60 dark:bg-white/30 text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Кнопка настроек Pro (если передана) */}
      {onOpenProSettings && (
        <button
          onClick={onOpenProSettings}
          className="p-1.5 rounded-lg hover:bg-white/10 dark:hover:bg-white/10 transition-colors"
          aria-label={t("proSettings")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-foreground">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        </button>
      )}
    </div>
  );
};